import { useEffect, useState } from 'react'
import { FiExternalLink } from 'react-icons/fi'

export default function WebsiteUrlCard({ url, className = '', embed = true }) {
  const [frameState, setFrameState] = useState(embed ? 'loading' : 'fallback')

  useEffect(() => {
    if (!embed || frameState !== 'loading') return undefined
    const timeoutId = window.setTimeout(() => setFrameState('fallback'), 4000)
    return () => window.clearTimeout(timeoutId)
  }, [embed, frameState])

  if (!url) return null

  let label = url
  try {
    label = new URL(url).hostname
  } catch {
    // Keep the original URL as the fallback label.
  }

  return (
    <div className={`relative flex aspect-video w-full min-h-[150px] flex-col overflow-hidden rounded-lg bg-slate-800 text-white ${className}`}>
      {embed && frameState !== 'fallback' && (
        <iframe
          src={url}
          title={`Website preview: ${label}`}
          className="absolute inset-0 h-full w-full border-0 bg-white"
          loading="lazy"
          sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
          referrerPolicy="no-referrer"
          onLoad={() => setFrameState('loaded')}
          onError={() => setFrameState('fallback')}
        />
      )}
      {(!embed || frameState === 'fallback') && (
        <div className="flex h-full w-full flex-col items-center justify-center gap-3 px-6 text-center">
          <FiExternalLink className="h-10 w-10" />
          <span className="text-sm font-semibold">Website Preview</span>
          <span className="max-w-full truncate text-xs text-white/70">{label}</span>
        </div>
      )}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => event.stopPropagation()}
        className="absolute bottom-2 left-1/2 z-10 -translate-x-1/2 rounded bg-black/70 px-3 py-1.5 text-xs font-semibold text-white hover:bg-black/90"
        aria-label="Visit website"
      >
        Visit Website
      </a>
    </div>
  )
}